/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreDiniViewerAliases {
  ACTION_INACTIVATE_SCORE_DINI = 'action-inactivate-score-dini',
  ACTION_NEW_SCORE_DINI = 'action-new-score-dini',
  ACTION_REFERENCE_SCORE_DINI = 'action-reference-score-dini',
  CONTEXTUAL_BAR = 'contextual-bar',
  FIELD_ACCOMPANYING_PARTICIPATION = 'field-accompanying-participation',
  FIELD_ACTIVITY = 'field-activity',
  FIELD_BODY_HYGIENE = 'field-body-hygiene',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_DRUG_THERAPY = 'field-drug-therapy',
  FIELD_ELIMINATIONS = 'field-eliminations',
  FIELD_EVALUATION_DATE = 'field-evaluation-date',
  FIELD_FOOD_AND_HYDRATION = 'field-food-and-hydration',
  FIELD_MOBILITY_AND_WALKING = 'field-mobility-and-walking',
  FIELD_MUCOSAL_INTEGRITY = 'field-mucosal-integrity',
  FIELD_OXYGENATION = 'field-oxygenation',
  FIELD_PROFESSIONAL = 'field-professional',
  FIELD_PUNCTUATION = 'field-punctuation',
  FIELD_RANGE_CONTROLS = 'field-range-controls',
  FIELD_RESULT = 'field-result',
  FIELD_SUPPORT_AND_NETWORK = 'field-support-and-network',
  FORM_SCORE_DINI_VIEWER = 'form-score-dini-viewer',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_EVATUALION_DATE = 'input-evatualion-date',
  LAYOUT_SCORE_DINI_VIEWER = 'layout-score-dini-viewer',
  TEXT_ACCOMPANYING_PARTICIPATION = 'text-accompanying-participation',
  TEXT_ACTIVITY = 'text-activity',
  TEXT_BODY_HYGIENE = 'text-body-hygiene',
  TEXT_DESCRIPTION = 'text-description',
  TEXT_DRUG_THERAPY = 'text-drug-therapy',
  TEXT_ELIMINATIONS = 'text-eliminations',
  TEXT_FOOD_AND_HYDRATION = 'text-food-and-hydration',
  TEXT_MOBILITY_AND_WALKING = 'text-mobility-and-walking',
  TEXT_MUCOSAL_INTEGRITY = 'text-mucosal-integrity',
  TEXT_OXYGENATION = 'text-oxygenation',
  TEXT_PROFESSIONAL = 'text-professional',
  TEXT_PUNCTUATION = 'text-punctuation',
  TEXT_RANGE_CONTROLS = 'text-range-controls',
  TEXT_RESULT = 'text-result',
  TEXT_SUPPORT_AND_NETWORK = 'text-support-and-network',
}
export { ScoreDiniViewerAliases };
